import React from 'react';
import { ResourceCenter } from 'cccisd-laravel-resources';

const Courses = () => {
    // Other stuff?
    return <ResourceCenter handle="courses" />;
};

export default Courses;
